import React from "react";
import type { ISvgProps } from "components/icons/shared_props";

import { MAIN_THEME } from "styles/theme";

export default function LeftIcon({
  size = "24",
  color = MAIN_THEME.colors.brandWhite,
}: ISvgProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 8 13"
      fill={color}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.957031 6.28516C0.792969 6.42188 0.738281 6.58594 0.738281 6.75C0.738281 6.94141 0.792969 7.10547 0.957031 7.21484L6.26172 12.5195C6.37109 12.6562 6.53516 12.7109 6.72656 12.7109C6.89062 12.7109 7.05469 12.6562 7.19141 12.5195L7.79297 11.918C7.90234 11.8086 7.98438 11.6445 7.98438 11.4531C7.98438 11.2891 7.92969 11.125 7.82031 10.9883L3.58203 6.75L7.82031 2.51172C7.92969 2.40234 7.98438 2.23828 7.98438 2.04688C7.98438 1.88281 7.90234 1.71875 7.79297 1.58203L7.19141 0.980469C7.05469 0.871094 6.89062 0.789062 6.72656 0.789062C6.53516 0.789062 6.37109 0.871094 6.26172 0.980469L0.957031 6.28516Z"
        fill="#888B8D"
      />
    </svg>
  );
}
